// src/pages/admin/emails/components/QueueItemDialog.tsx
import { useMemo } from "react";

export default function QueueItemDialog({
  row,
  onClose,
}: {
  row: any;
  onClose: () => void;
}) {
  const payloadPretty = useMemo(() => {
    try {
      return JSON.stringify(row.payload ?? {}, null, 2);
    } catch {
      return String(row.payload ?? "");
    }
  }, [row.payload]);

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50">
      <div className="bg-[#161b27] border border-[#2a3347] w-full max-w-3xl rounded-xl shadow-xl overflow-hidden">
        <div className="flex items-center justify-between px-4 py-3 border-b border-[#2a3347]">
          <h3 className="font-semibold text-lg text-slate-100">Queue-Detail</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-200">✕</button>
        </div>
        <div className="p-4 space-y-3 text-sm">
          <Row label="ID" value={<code className="text-sky-400">{row.id}</code>} />
          <Row label="Status" value={row.status} />
          <Row label="Vorlage" value={row.email_templates?.name ?? row.template_id} />
          <Row label="User" value={`${row.profiles?.email ?? "—"} (${row.user_id})`} />
          <Row label="not_before" value={new Date(row.not_before).toLocaleString()} />
          <Row label="try_count" value={row.try_count} />
          <Row label="dedupe_key" value={<code className="break-all text-sky-400">{row.dedupe_key}</code>} />
          {row.last_error && (
            <Row
              label="last_error"
              value={<pre className="text-red-400 bg-red-950/20 border border-red-800/30 rounded p-2 whitespace-pre-wrap">{row.last_error}</pre>}
            />
          )}
          <div>
            <div className="text-slate-400 mb-1">Payload</div>
            <pre className="bg-[#0d1117] border border-[#2a3347] rounded p-3 text-xs overflow-auto max-h-[40vh] text-slate-300">
              {payloadPretty}
            </pre>
          </div>
          <div className="text-xs text-slate-500">
            Erstellt: {new Date(row.created_at).toLocaleString()} • Aktualisiert:{" "}
            {new Date(row.updated_at).toLocaleString()}
          </div>
        </div>
        <div className="px-4 py-3 border-t border-[#2a3347] flex justify-end">
          <button onClick={onClose} className="px-4 py-2 bg-sky-500 text-white rounded-lg hover:bg-sky-600 transition-colors">
            Schließen
          </button>
        </div>
      </div>
    </div>
  );
}

function Row({ label, value }: { label: string; value: any }) {
  return (
    <div className="grid grid-cols-3 gap-3">
      <div className="text-slate-500">{label}</div>
      <div className="col-span-2 text-slate-300">{value}</div>
    </div>
  );
}
